// assets
import { Category, ShoppingBag, TableDocument, ShoppingCart, Calculator, Heart, Brodcast } from 'iconsax-react';

// icons
const icons = {
    Category: Category, ShoppingBag, TableDocument, ShoppingCart, Calculator, Heart, Brodcast
};

let children = [];

children = [
    {
        id: 'analytics',
        title: 'Analytics',
        type: 'item',
        url: '/analytics',
        icon: icons.Calculator,
        breadcrumbs: false
    },
    {
        id: 'advertisement-new',
        title: 'Advertisements',
        type: 'item',
        url: '/advertisement-new',
        icon: icons.Brodcast,
        breadcrumbs: false
    },
    {
        id: 'flash-deals',
        title: 'Flash Deals',
        type: 'item',
        url: '/flash-deals',
        icon: icons.Brodcast,
        breadcrumbs: false
    },
    {
        id: 'new-arrivals',
        title: 'New Arrivals',
        type: 'item',
        url: '/new-arrivals',
        icon: icons.ShoppingBag,
        breadcrumbs: false
    },
    {
        id: 'users',
        title: 'Users',
        type: 'item',
        url: '/users',
        icon: icons.TableDocument,
        breadcrumbs: false
    },
    // {
    //     id: 'advertisement',
    //     title: 'Advertisement',
    //     type: 'item',
    //     url: '/advertisement',
    //     icon: icons.Brodcast,
    //     breadcrumbs: false
    // },
    {
        id: 'product',
        title: 'Products',
        type: 'item',
        url: '/products',
        icon: icons.ShoppingBag,
        breadcrumbs: false
    },
    {
        id: 'category',
        title: 'Categories',
        type: 'item',
        url: '/categories',
        icon: icons.Category,
        breadcrumbs: false
    },
    // {
    //     id: 'form',
    //     title: 'Repairing Forms',
    //     type: 'item',
    //     url: '/forms',
    //     icon: icons.TableDocument,
    //     breadcrumbs: false
    // },
    // {
    //     id: 'favorites',
    //     title: 'Favorites',
    //     type: 'item',
    //     url: '/favorites',
    //     icon: icons.Heart,
    //     breadcrumbs: false
    // },
    {
        id: 'order',
        title: 'Orders',
        type: 'collapse',
        icon: icons.ShoppingCart,
        children: [
            {
                id: 'allOrders',
                title: 'All Orders',
                type: 'item',
                url: '/orders/all',
                breadcrumbs: false
            },
            {
                id: 'inProgressOrders',
                title: 'Pending Orders',
                type: 'item',
                url: '/orders/pending',
                breadcrumbs: false
            },
            {
                id: 'completedOrders',
                title: 'Completed Orders',
                type: 'item',
                url: '/orders/completed',
                breadcrumbs: false
            },
            {
                id: 'acceptedOrders',
                title: 'Accepted Orders',
                type: 'item',
                url: '/orders/accepted',
                breadcrumbs: false
            },
            {
                id: 'shippedOrders',
                title: 'Shipped Orders',
                type: 'item',
                url: '/orders/shipped',
                breadcrumbs: false
            },
            {
                id: 'rejectedOrders',
                title: 'Rejected Orders',
                type: 'item',
                url: '/orders/rejected',
                breadcrumbs: false
            }
        ]
    },
]
const tabs = {
    id: 'group-tabs',
    title: '',
    icon: icons.tabs,
    type: 'group',
    children
};

export default tabs;
